import { returnFromLimitVerification } from '../checkout/funding-limit-recovery.js';
import { fundingCheckoutBack } from '../operations/navigation.js';
export function fundingProfileActions(options) {
    const { state, attemptId, busy, navigation, discovery } = options;
    return {
        back() {
            if (state === 'status') {
                navigation.deposit();
                return;
            }
            if (busy)
                return;
            if (returnFromLimitVerification(options.progress, navigation, attemptId))
                return;
            if (returnToFundingProfile(options.progress, navigation, attemptId))
                return;
            const target = fundingCheckoutBack(state);
            if (attemptId)
                navigation.deposit();
            else if (target === 'methods') {
                options.progress.verificationRequested = false;
                navigation.transition('change_method');
            }
            else if (target === 'amount')
                navigation.transition('edit_amount');
            else if (target === 'review')
                navigation.transition('quote_ready');
            else if (target === 'connection_required')
                navigation.transition('connection_required');
        },
        openProfile() {
            if (state !== 'methods' || attemptId || busy)
                return;
            navigation.transition('profile_requested');
        },
        profileUpdated() {
            if (state !== 'profile' || attemptId || busy)
                return;
            if (discovery.data?.customerVerification)
                options.refreshCustomer();
            else
                options.options.onSessionRefresh();
            navigation.transition('profile_requested');
        },
        profileVerify() {
            if (state !== 'profile' || attemptId || busy)
                return;
            const current = discovery.data;
            const verification = current?.customerVerification;
            if (verification &&
                (verification.status === 'collecting' ||
                    verification.status === 'not_created' ||
                    verification.challenge)) {
                options.progress.verificationFromProfile = true;
                navigation.transition('customer_verification_required');
            }
            else if ((current?.guest && current.methods.length > 0) ||
                (current?.status === 'connectionRequired' &&
                    current.authenticationAvailable &&
                    current.authenticationReason !== 'account_mismatch')) {
                options.progress.verificationFromProfile = true;
                navigation.transition('connect_requested');
            }
        },
    };
}
export function returnToFundingProfile(progress, navigation, attemptId) {
    if (!progress.verificationFromProfile || attemptId)
        return false;
    progress.verificationFromProfile = false;
    navigation.transition('profile_requested');
    return true;
}
